import CriarConta from '../components/CriarConta'

let routes = {
    path: '/criar-conta',
    component: resolve => require(['../components/layout/Login'], resolve),
    children: [
        {
            path: '/criar-conta',
            name: 'CriarConta',
            component: CriarConta
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/criar-conta.js